module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/cart-3-f600d1abc166e6ca66275197a1ca7031.svg";